import EggsProduct from 'models/EggsProduct'

export const packagingInitialState = {
  category: EggsProduct.category,
  subCategory: EggsProduct.subCategory,
  ContainerSize: EggsProduct.ContainerSize,
  CASEFSCompliantCertification: EggsProduct.CASEFSCompliantCertification,
  EggShellColorCertification: EggsProduct.EggShellColorCertification,
}
